import InputBase from "@mui/material/InputBase"
import { styled } from "@mui/material/styles"

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  background: "var(--mui-palette-background-paper)",
  border: "1px solid var(--mui-palette-divider)",
  backgroundColor: "rgba(60, 60, 60, 0.25)",
  "&:hover": {
    backgroundColor: "rgba(60, 60, 60, 0.5)",
  },
  "&:focus-within": {
    backgroundColor: "rgba(60, 60, 60, 0.5)",
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
    minWidth: 400,
  },
  color: "var(--mui-palette-text-primary)",
}))

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "var(--mui-palette-text-secondary)",
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: "9px 8px",
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      "&:focus": {
        // width: "24ch",
      },
    },
  },
  "& .MuiInputBase-input::placeholder": {
    fontSize: "0.85rem",
    lineHeight: 1,
  },
  "& .MuiAutocomplete-endAdornment": {
    right: 8,
  },
}))

export { Search, SearchIconWrapper, StyledInputBase }
